/* Peak Labs - Nasal spray product pages. window.SpraysPage (listing) + window.SprayDetail (PDP).
   Sprays are LIVE/buyable (real Shopify products, numeric variantId). Research-use-only framing.
   Reads React, Icon, SPRAY_IMAGES, submitCartToShopify. */
(function () {
  if (typeof window === "undefined" || !window.React) return;
  var h = React.createElement;
  function Icon(p) { var I = window.Icon; return I ? h(I, p) : null; }
  function img(id) { return (window.SPRAY_IMAGES || {})[id] || ""; }
  function dhs(n) { return n == null ? "" : (window.formatDhs ? window.formatDhs(n) : "AED " + n); }

  var SPRAYS = [
    { id: "selank-spray", handle: "selank-nasal-spray", name: "Selank", mg: 10, price: 599, variantId: 46214645710984, cat: "Cognitive & Sleep", sub: "Heptapeptide · Tuftsin analogue",
      blurb: "Selank is a synthetic heptapeptide research compound (a Tuftsin analogue), supplied as a pre-filled metered nasal spray for laboratory research use." },
    { id: "semax-spray", handle: "semax-nasal-spray", name: "Semax", mg: 10, price: 599, variantId: 46214645743752, cat: "Cognitive & Sleep", sub: "ACTH(4-10) analogue peptide",
      blurb: "Semax is a synthetic peptide research compound (an ACTH(4-10) fragment analogue), supplied as a pre-filled metered nasal spray for laboratory research use." },
    { id: "pt-141-spray", handle: "pt-141-nasal-spray", name: "PT-141", mg: 10, price: 699, variantId: 46214645776520, cat: "Libido & Vitality", sub: "Melanocortin peptide (bremelanotide)",
      blurb: "PT-141 (bremelanotide) is a melanocortin research peptide, supplied as a pre-filled metered nasal spray for laboratory research use." }
  ];
  window.PL_SPRAYS = SPRAYS;
  function bySlug(s) { for (var i = 0; i < SPRAYS.length; i++) if (SPRAYS[i].id === s) return SPRAYS[i]; return null; }
  function nav(on, path) { return function (e) { e.preventDefault(); on ? on(path) : (location.hash = "#" + path); }; }

  /* Availability, driven by live Shopify stock (same source of truth as vials/pens).
     Server-rendered into window.SPRAY_STOCK by index.liquid; re-checked live below so
     an in-stock/out-of-stock flip in Shopify shows without waiting for a publish.
     Defaults to available when unknown (e.g. local preview with no SPRAY_STOCK). */
  function avail(s) { var m = window.SPRAY_STOCK || {}; return Object.prototype.hasOwnProperty.call(m, s.id) ? !!m[s.id] : true; }
  var stockSubs = [];
  function onStockChange(fn) { stockSubs.push(fn); return function () { stockSubs = stockSubs.filter(function (x) { return x !== fn; }); }; }
  var _stockChecked = false;
  function checkStock() {
    if (_stockChecked) return; _stockChecked = true;
    SPRAYS.forEach(function (s) {
      if (!s.handle) return;
      fetch("/products/" + encodeURIComponent(s.handle) + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          var a = !!d.available;
          window.SPRAY_STOCK = window.SPRAY_STOCK || {};
          if (window.SPRAY_STOCK[s.id] !== a) { window.SPRAY_STOCK[s.id] = a; stockSubs.forEach(function (fn) { try { fn(); } catch (e) {} }); }
        })
        .catch(function () { /* offline or blocked - keep server-rendered value */ });
    });
  }
  function useStock() {
    var t = React.useState(0);
    React.useEffect(function () { checkStock(); return onStockChange(function () { t[1](function (n) { return n + 1; }); }); }, []);
  }

  function cartProduct(s) { return { id: s.id, name: s.name, dose: s.mg + " mg", price: s.price, variantId: s.variantId, image: img(s.id), category: "vitality", available: avail(s) }; }
  function addSpray(s, buyNow, onAdd, qty) {
    if (!avail(s)) return;
    qty = Math.max(1, qty || 1);
    var c = cartProduct(s);
    if (buyNow && window.submitCartToShopify) {
      window.submitCartToShopify([{ product: c, qty: qty }], {}).then(function (ok) { if (!ok && onAdd) onAdd(c, qty, false, true); }).catch(function () { if (onAdd) onAdd(c, qty, false, true); });
    } else if (onAdd) { onAdd(c, qty, false, true); }
  }

  /* ---------- listing: /sprays ---------- */
  window.SpraysPage = function (props) {
    var on = props && props.onNavigate, onAdd = props && props.onAddToCart;
    useStock();
    return h("main", { id: "main", tabIndex: -1, className: "sp" },
      h("section", { className: "section sp-hero" }, h("div", { className: "sp-wrap" },
        h("p", { className: "eyebrow" }, "Nasal sprays"),
        h("h1", { className: "sp-hero__h1" }, "Metered nasal sprays, no needles."),
        h("p", { className: "sp-hero__lede" }, "Pre-filled research nasal sprays with a metered pump. Selank, Semax and PT-141."),
        h("span", { className: "pl-divider" }))),
      h("section", { className: "section sp-list" }, h("div", { className: "sp-wrap" },
        h("div", { className: "sp-cards" }, SPRAYS.map(function (s) {
          return h("div", { className: "sp-card", key: s.id },
            h("a", { className: "sp-card__link", href: "#/spray/" + s.id, onClick: nav(on, "/spray/" + s.id) },
              h("div", { className: "sp-card__img" }, img(s.id) ? h("img", { src: img(s.id), alt: s.name + " nasal spray", loading: "lazy", decoding: "async" }) : null),
              h("div", { className: "sp-card__body" },
                h("span", { className: "sp-card__sub" }, s.cat || s.sub),
                h("h2", { className: "sp-card__name" }, s.name, " ", h("span", null, s.mg + " mg")),
                s.price ? h("span", { className: "sp-card__price" }, dhs(s.price)) : null)),
            h("div", { className: "sp-card__buy" },
              avail(s)
                ? h("button", { className: "product-card__add", type: "button", onClick: function () { addSpray(s, false, onAdd); }, "aria-label": "Add " + s.name + " to cart" }, h(Icon, { name: "cart", size: 15 }), h("span", null, "Add to cart"))
                : h("button", { className: "product-card__add", type: "button", disabled: true, "aria-label": s.name + " out of stock" }, h("span", null, "Out of Stock"))));
        })))),
      ruo());
  };

  /* ---------- PDP: /spray/<id> ---------- */
  window.SprayDetail = function (props) {
    var on = props && props.onNavigate, onAdd = props && props.onAddToCart, s = bySlug(props && props.slug);
    var qs = React.useState(1), qty = qs[0], setQty = qs[1];
    useStock();
    if (!s) return h("main", { id: "main", className: "sp" }, h("section", { className: "section sp-wrap" }, h("p", null, "Spray not found. "), h("a", { href: "#/sprays", onClick: nav(on, "/sprays") }, "Back to sprays")));
    var inStock = avail(s);
    return h("main", { id: "main", tabIndex: -1, className: "sp" },
      h("section", { className: "section" }, h("div", { className: "sp-wrap" },
        h("div", { className: "breadcrumb" }, h("a", { href: "#/sprays", onClick: nav(on, "/sprays") }, "Sprays"), h("span", { className: "sep" }, "·"), h("span", null, s.name)),
        h("div", { className: "sp-pdp" },
          h("div", { className: "sp-pdp__media" }, img(s.id) ? h("img", { src: img(s.id), alt: s.name + " nasal spray", loading: "eager", decoding: "async" }) : null),
          h("div", { className: "sp-pdp__info" },
            h("span", { className: "eyebrow" }, "Research nasal spray"),
            h("h1", { className: "sp-pdp__h1" }, s.name, " ", h("span", { className: "sp-pdp__mg" }, s.mg + " mg")),
            h("p", { className: "sp-pdp__blurb" }, s.blurb),
            h("div", { className: "sp-pdp__facts" },
              h("span", { className: "sp-pdp__factslabel" }, "What you get"),
              h("ul", null,
                h("li", null, "Amber glass bottle with a metered nasal pump, pre-filled and ready to use"),
                h("li", null, s.mg + " mg in the bottle · each spray releases about 0.1 mL"),
                h("li", null, "No needles, no mixing, no draw-up"))),
            h("div", { className: "sp-pdp__buy" },
              s.price ? h("div", { className: "sp-pdp__price" }, dhs(s.price), inStock ? null : h("span", { className: "sp-pdp__oos", style: { marginInlineStart: 10, fontSize: ".7em", fontWeight: 600, letterSpacing: ".05em", textTransform: "uppercase", color: "var(--pl-fg-3)" } }, "Out of stock")) : null,
              (s.price && window.plTamaraNote) ? h(window.plTamaraNote, { price: s.price }) : null, /*pl-tamara-note*/
              inStock ? h("div", { className: "cart-row__qty sp-pdp__qty" },
                h("button", { type: "button", onClick: function () { setQty(Math.max(1, qty - 1)); }, "aria-label": "Decrease quantity" }, "−"),
                h("span", null, qty),
                h("button", { type: "button", onClick: function () { setQty(qty + 1); }, "aria-label": "Increase quantity" }, "+")) : null,
              inStock
                ? h("div", { className: "pdp__ctas" },
                    h("button", { className: "btn btn--primary btn--lg", onClick: function () { addSpray(s, false, onAdd, qty); } }, h(Icon, { name: "cart", size: 16 }), " Add to Cart"))
                : h("div", { className: "pdp__ctas" },
                    h("button", { className: "btn btn--primary btn--lg", type: "button", disabled: true, style: { opacity: .55, cursor: "not-allowed" } }, "Out of Stock")),
              h("a", { className: "sp-pdp__back", href: "#/sprays", onClick: nav(on, "/sprays") }, "← All sprays")))))),
      window.CalcEmbed ? h(window.CalcEmbed, { mode: "spray", initKey: s.id, heading: "Dose this spray" }) : null,
      ruo());
  };

  function ruo() {
    return h("section", { className: "section sp-ruo" }, h("div", { className: "sp-wrap" },
      h("p", { className: "sp-ruo__text" }, "All products sold by Peak Labs are intended for laboratory research use only. They are not intended for human consumption, therapeutic use, diagnostic application, or veterinary use. Peak Labs makes no medical or therapeutic claims.")));
  }
})();
